import { React, useState } from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import { Section } from "react-scroll-section";
import { CarouselProvider } from "pure-react-carousel";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarouselSlider from "./White_label_slider";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

// import White-lable-slider from "../../"
function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  const processes_feture = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  const [slideCount, setSlideCount] = useState(3);
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <div className="newpage blog_page white_label white_label_SR">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner white-label-service">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                White Label Cryptocurrency Exchange Software | Beleaf
                Technologies
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/white-label-cryptocurrency-exchange-software"
              />
              <meta
                name="title"
                content="White Label Cryptocurrency Exchange Software | Beleaf Technologies"
              />
              <meta
                name="description"
                content="Beleaf technology is the leading white label crypto exchange software development company that provides white label crypto software solutions to build a profitable and reliable crypto exchange platform in the stipulated time period.
                "
              />
              <meta
                name="keywords"
                content="White Label Crypto Exchange Software, White Label Cryptocurrency Exchange, Cryptocurrency Exchange Software, White label exchange software, White label crypto exchange platform, White label bitcoin exchange software, white label exchange solutions"
              />
            </Helmet>
            <section className="cexnew_section1_ik">
              <div className="container">
                <div className="row ">
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="cex_section1_content_ik white_label_hero_section_title">
                      <h1>White Label Crypto Exchange Software</h1>
                      <p className="cexnew_p_ik white_label_content">
                        Start your own bitcoin exchange company right away using
                        our top white label crypto exchange software….!!
                      </p>
                      <div
                        className="cexnew_button_ik white_button"
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        Get Free Consultation
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="cex_section1_img_ik">
                      <img
                        src={require("../../image/new_white_lable/white_label_hero_banner.webp")}
                        className="white_banner"
                        alt="White label Crypto Exchange Software"
                      ></img>
                      {/* <img
                        src={require("../../image/new_white_lable/banner_coins.png")}
                        className="banner_coins"
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="">
              <div className="container">
                <div className="row">
                  <div className=" col-md-6 col-lg-6 img_section menimg_section">
                    <img
                      src={require("../../image/new_white_lable/white_second_banner.webp")}
                      alt="White label Crypto Exchange Software"
                      className="white_banner"
                    />
                    <img
                      src={require("../../image/new_white_lable/white_label_coins.webp")}
                      alt="White label Crypto Exchange Software"
                      className="banner_coins top"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto second_section_crypto second_white_section">
                      <h2 className="text-center white_sub_heading">
                        White Label Crypto Exchange Software
                      </h2>
                      <p className="white_label_content">
                        White label crypto exchange software is a ready-made
                        exchange software meant to provide crypto and token
                        trading as well as many trade alternatives. The White
                        label crypto exchange software is a turnkey software
                        solution that contributes to user-friendly UI/UX
                        designs, a powerful matching engine, order book systems,
                        liquidity provision tools, and tamper-proof security
                        implementations. Beleaf Technology is a world-class
                        white label crypto trading software solution that will
                        help investors by allowing them to easily launch their
                        crypto exchange platform.
                        <Button
                          data-toggle="modal"
                          data-target="#myModal"
                          aria-label="Share Your Business Requirements With Us"
                          className="white_button"
                        >
                          Share Your Business Requirements With Us
                        </Button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="white_features_section">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className=" white-feature">
                        Features of our White Label Crypto Exchange Software
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto features_white_content">
                      <p>
                        Our exchange software is designed with cutting-edge
                        capabilities to give you a distinct advantage in the
                        decentralized market. Use the following features to
                        successfully launch your crypto exchange in the digital
                        world.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/high-speed.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>High-Speed Transactions</h3>
                      <p>
                        In order to provide a seamless and trouble-free trading
                        experience, our crypto exchange software enables huge
                        performance processing of up to 100,000 transactions per
                        second.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/multi-wallet.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Multi-Wallet Integration</h3>
                      <p>
                        Multiple cryptocurrency wallet integrations allow for
                        secure crypto storage and smooth transactions.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/kyc-support.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>KYC Support</h3>
                      <p>
                        If there are any large withdrawals from the hot wallet,
                        geo-based user identification verification is
                        implemented as a KYC for security reasons.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/refer.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Refer and Earn</h3>
                      <p>
                        Users benefit from the referral and reward program,
                        which also allows for quiet liquidity in cryptocurrency
                        trading by earning incentives.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/staking.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Staking</h3>
                      <p>
                        You may keep your users engaged by providing staking
                        perks through their crypto assets, allowing them to earn
                        significant rewards.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/engine.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Robust Engine</h3>
                      <p>
                        We provide and implement a robust engine in our software
                        to process purchasing and selling orders.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/fiat.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Fiat Currency Support</h3>
                      <p>
                        We boost scalability by adding these to our white label
                        exchange software, which supports many currencies,
                        including fiats.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/liquidity.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Perfect Liquidity</h3>
                      <p>
                        You will have the right liquidity choice with a secure
                        connection if both ends of the buying and selling fail.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white high_card blue_card_lable">
                      <img
                        src={require("../../image/new_white_lable/language.webp")}
                        alt="White label Crypto Exchange Software"
                        className=""
                      />
                      <h3>Multi-Language Support</h3>
                      <p>
                        By integrating numerous language support, your crypto
                        exchange software is readily visible and accessible all
                        around the world.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row pt-5">
                  <div className="col-lg-6">
                    <div className="first_section_crypto white_security_content">
                      <h2 className="">Security Features</h2>

                      <ul className="security-feature-list">
                        <li>
                          <span>
                            <img
                              src={require("../../image/new_white_lable/Line 1.webp")}
                              alt="White label Crypto Exchange Software"
                              className="security-line"
                            />
                          </span>
                          Anti-DDoS Setup
                        </li>
                        <li>
                          <span>
                            <img
                              src={require("../../image/new_white_lable/Line 1.webp")}
                              alt="White label Crypto Exchange Software"
                              className="security-line"
                            />
                          </span>
                          CSRF Protection
                        </li>
                        <li>
                          <span>
                            <img
                              src={require("../../image/new_white_lable/Line 1.webp")}
                              alt="White label Crypto Exchange Software"
                              className="security-line"
                            />
                          </span>
                          GDPR Compliance
                        </li>
                        <li>
                          <span>
                            <img
                              src={require("../../image/new_white_lable/Line 1.webp")}
                              alt="White label Crypto Exchange Software"
                              className="security-line"
                            />
                          </span>
                          SSRF Protection
                        </li>
                        <li>
                          <span>
                            <img
                              src={require("../../image/new_white_lable/Line 1.webp")}
                              alt="White label Crypto Exchange Software"
                              className="security-line"
                            />
                          </span>
                          Time Limited Transactions
                        </li>

                        <li>
                          <span>
                            <img
                              src={require("../../image/new_white_lable/line2.webp")}
                              alt="White label Crypto Exchange Software"
                              className="security-line"
                            />
                          </span>
                          2FA Security Provision
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 img_section menimg_section ">
                    <img
                      src={require("../../image/new_white_lable/security_features_img.webp")}
                      alt="White label Crypto Exchange Software"
                      className="security-banner"
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="specialize_section">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-6">
                    <div className="wazirx_benefitssec_title">
                      {/*  */}
                      <h2 className="wazirx_h2 mb-2 specialize_h2">
                        Our Specialized White Label Crypto Exchange Software
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="wazirx_benefitssec_cardarea mt-5">
                  <Slider {...processes_newew}>
                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/exchange.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">Centralized Exchange</h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          In centralized exchanges, a central authority performs
                          trade between the seller and buyer, giving the user
                          significant security and complete access to their
                          private keys.
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/Decentralized.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">
                          Decentralized <br /> Exchange
                        </h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          Decentralized exchanges eliminate the central
                          authority to facilitate peer-to-peer transactions,
                          reducing the danger of hacking and fraudulent
                          activity.
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/hybird.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">Hybrid Exchange</h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          Hybrid exchanges combine the benefits of centralized
                          and decentralized exchanges, providing traders with
                          continuous liquidity, quick transactions, and so on.
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/p2p.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">P2P Crypto Exchange</h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          The P2P crypto exchange concept works by letting users
                          to trade directly without the necessity of a middleman
                          and by facilitating an escrow protection mechanism.{" "}
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/defi.png")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">Defi Exchange</h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          The DeFi exchanges work mostly on decentralization to
                          trade multiple coins from several chains.{" "}
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/wallet.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">White Label Crypto Wallet</h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          The white label crypto wallet helps customers by
                          storing, trading, and exchanging a large number of
                          cryptocurrencies while also assuring safe
                          transactions.
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/exchangapp.png")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">
                          {" "}
                          White Label Crypto Exchange APP
                        </h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          The white label crypto exchange software makes
                          transactions more effective for customers and adds
                          mobility to the crypto trading experience.
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>

                    <div className="Specialize-card">
                      <div className="exchange-logo ">
                        <img
                          src={require("../../image/new_white_lable/bitcoin.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h2 className="mt-0">White label Bitcoin Exchange</h2>
                      </div>
                      <div className="exchange-content">
                        <p>
                          A white label bitcoin exchange is a dedicated platform
                          that allows customers to trade bitcoins using powerful
                          matching and trading engines.
                        </p>
                        <button>
                          Learn More <i className="ri-arrow-right-line"></i>
                        </button>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </section>

            <section className="meme_coins_card_section">
              <div className="container">
                <div className="meme_coin_card_title bussiness_benifit">
                  <h1 className="business-benefit-max-width">
                    Business Benefits Of Our White Label Crypto Exchange
                    Software
                  </h1>
                </div>
                <p className="benifit-content benfit-content-mw">
                  Here are the advantages of using our white label crypto
                  exchange software, which is responsible for the platform's
                  remarkable performance.
                </p>
                <div className="carousel-container">
                  <CarouselProvider
                    visibleSlides={slideCount}
                    totalSlides={9}
                    step={1}
                    currentSlide={currentSlide}
                    naturalSlideWidth={100}
                    naturalSlideHeight={125}
                    isIntrinsicHeight={true}
                  >
                    <CarouselSlider
                      setSlideCount={setSlideCount}
                      setCurrentSlide={setCurrentSlide}
                    />
                  </CarouselProvider>
                </div>
              </div>
            </section>

            <section className="why_white_content ">
              <div className="container">
                <div className="meme_coin_card_title bussiness_benifit">
                  <h1 className="">
                    Why Use White Label Crypto Exchange Software When Starting A
                    Cryptocurrency Exchange?
                  </h1>
                </div>
                <p className="benifit-content">
                  You may gain several benefits by utilizing our top white label
                  crypto exchange software to establish your thriving
                  cryptocurrency exchange business.
                </p>
                <div className="row pt-5">
                  <div className="col-lg-6">
                    <div className="first_section_crypto white_security white_benifit">
                      <ul className="why_content-list">
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          Bug-free & secure
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          Faster deployment
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          No need for technical expertise
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          Eye-catching and user-friendly dashboard
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          Highly customizable
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          Cost-effective
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          Easy-to-use platform
                        </li>
                        <li>
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="w-6 h-6"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                              />
                            </svg>
                          </span>
                          High ROI
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-6 menimg_section">
                    <img
                      src={require("../../image/new_white_lable/why-content-banner.webp")}
                      alt="White label Crypto Exchange Software"
                      className="img-fluid cla_benifir"
                    />
                    <img
                      src={require("../../image/new_white_lable/why-content-coin.webp")}
                      alt="White label Crypto Exchange Software"
                      className="banner_coins why-coin-air"
                    />
                  </div>
                </div>
              </div>
            </section>

            <section className="development-process-section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-5">
                    <div className="development-process-content">
                      <h2 className="specialize_h2 text-left">
                        Our white label crypto exchange software
                      </h2>
                      <p className="white_label_content">
                        It's a collection of procedures that contribute to the
                        creation of a platform that provides Crypto Exchange
                        based on user-suggested requirements and customizations.
                        The procedure is carried out in several phases, which
                        include.
                      </p>
                      <img
                        src={require("../../image/new_white_lable/development-process-coin.webp")}
                        alt="White label Crypto Exchange Software"
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 exchange-development-card margin-card2">
                    <div className="col-lg-6">
                      <div className="process-card ">
                        <img
                          src={require("../../image/new_white_lable/project-logo.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h3 className="tech-title">Project Analysis</h3>
                        <p className="process-content">
                          Our business analysts thoroughly examine current
                          market trends before developing the precise project
                          aim and goals for the business module.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="process-card margin-card2">
                        <img
                          src={require("../../image/new_white_lable/development-stage.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h3 className="tech-title">Development Stage </h3>
                        <p className="process-content">
                          Following the testing process, the exchange platform
                          is completely automated and responsive by merging
                          front-end and back-end features.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="process-card process-card-3">
                        <img
                          src={require("../../image/new_white_lable/analysis.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h3 className="tech-title">
                          Analysis of Client Requirements
                        </h3>
                        <p className="process-content">
                          Client requirements are determined based on their
                          business requirements, and technical resources such as
                          software, tools, and technologies to be included are
                          discussed.{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="process-card margin-card2 project-analysis-box">
                        <img
                          src={require("../../image/new_white_lable/hybird-exchanhe.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h3 className="tech-title">Hybrid Exchange</h3>
                        <p className="process-content">
                          The testing stage allows the platform to go through a
                          number of tests, such as User Acceptance Testing, to
                          determine its resistance to forthcoming hack assaults
                          and intruder attacks.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="process-card process-card-3">
                        <img
                          src={require("../../image/new_white_lable/method.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h3 className="tech-title">Design Methodology</h3>
                        <p className="process-content">
                          The Design stage allows developers to receive a
                          skeleton design of the Exchange Platform's interface,
                          and the design will be built in such a way that it
                          promotes an increasing number of participants on the
                          platform.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="process-card margin-card2 project-analysis-box">
                        <img
                          src={require("../../image/new_white_lable/project-logo.webp")}
                          alt="White label Crypto Exchange Software"
                        />
                        <h3 className="tech-title">Project Implementation</h3>
                        <p className="process-content">
                          Following the testing process, the created exchange
                          platform will be hosted on the client's server. The
                          platform receives post-maintenance and security
                          upgrades on a regular basis.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className=" section our_process">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter tech-title">
                        Tech Stack We Use{" "}
                      </h2>
                      <p className="text-center white_label_content">
                        We employ a high-end technological stack in the
                        centralized exchange-building process to supply you with
                        a top-notch digital solution. Our use of the
                        tried-and-true tech stack paradigm saves you time and
                        money in real ways.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Slider {...processes_newew}>
                  <div className="logo_clinet_img">
                    <img
                      src={require("../../image/new_white_lable/git-hub.webp")}
                      alt="White label Crypto Exchange Software"
                    />
                  </div>
                  <div className="logo_clinet_img">
                    <img
                      src={require("../../image/new_white_lable/node-js.webp")}
                      alt="White label Crypto Exchange Software"
                    />
                  </div>
                  <div className="logo_clinet_img">
                    <img
                      src={require("../../image/new_white_lable/angular.webp")}
                      alt="White label Crypto Exchange Software"
                    />
                  </div>
                  <div className="logo_clinet_img">
                    <img
                      src={require("../../image/new_white_lable/react.webp")}
                      alt="techstack"
                    />
                  </div>
                  <div className="logo_clinet_img">
                    <img
                      src={require("../../image/new_white_lable/mango-db.webp")}
                      alt="White label Crypto Exchange Software"
                    />
                  </div>
                </Slider>
              </div>
            </section>
            <section>
              <div className="container">
                <div className="row software_row">
                  <div className="col-lg-12 d-flex">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter tech-title first_section-mx-title">
                        Why Beleaf Technology For White Label Crypto Exchange
                        Software Development?
                      </h2>
                      <p className="text-center white_label_content">
                        Discover remarkable expertise and reliability with
                        Beleaf Technologies for your white label{" "}
                        <a href="/cryptocurrency-exchange-development-company">
                          crypto exchange software
                        </a>{" "}
                        needs. Our commitment to innovation ensures advanced
                        solutions developed to your requirements. Experience
                        seamless collaboration and superior support every step
                        of the way. Choose Beleaf Technologies for a white label
                        crypto exchange software that sets you apart in the
                        digital asset world.
                      </p>
                    </div>
                  </div>
                  <div className="footer-software-section">
                    <div className="col-lg-6">
                      <div className="footer-software-banner">
                        <img
                          src={require("../../image/new_white_lable/software-banner.webp")}
                          className="software-image"
                          alt="White label Crypto Exchange Software"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 m-auto">
                      <div className="first_section_crypto white_security white_benifit">
                        <ul className="why_content-list software-list">
                          <li>
                            <span>
                              <i className="ri-arrow-right-line"></i>
                            </span>
                            High Protection & Security
                          </li>
                          <li>
                            <span>
                              <i className="ri-arrow-right-line"></i>
                            </span>
                            Standard Quality
                          </li>
                          <li>
                            <span>
                              <i className="ri-arrow-right-line"></i>
                            </span>
                            Effective Liquidity
                          </li>
                          <li>
                            <span>
                              <i className="ri-arrow-right-line"></i>{" "}
                            </span>
                            Excellent Crypto Developer Team
                          </li>
                          <li>
                            <span>
                              <i className="ri-arrow-right-line"></i>
                            </span>
                            Quick Delivery and Launch
                          </li>
                          <li>
                            <span>
                              <i className="ri-arrow-right-line"></i>
                            </span>
                            24/7 Customer Support
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What exactly is white label crypto exchange
                                    software?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    White Label Crypto Exchange software is
                                    prepackaged software. This programme
                                    provides significant features, a passionate
                                    UI, stalwart APIs, and exceptionally
                                    mind-blowing capability to crypto traders.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    Where can I obtain the greatest white label
                                    crypto exchange software that is bug-free?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    When consumers look for the greatest and
                                    most bug-free white label crypto exchange
                                    software, they inevitably come across Beleaf
                                    technology. We provide a highly configurable
                                    white label crypto exchange software
                                    solution with amazing functionality and an
                                    exceptional user interface to guarantee your
                                    users have a seamless trading experience.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    What are the income sources of white label
                                    crypto exchange software?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Starting a crypto exchange business with the
                                    best white label crypto exchange software
                                    allows you to earn money in a variety of
                                    ways. Such as withdrawal fees, transaction
                                    costs, deposit fees, margin trading,
                                    stacking, and integrating the IEO launchpad
                                    into your exchange.
                                  </div>
                                </div>
                              </div>

                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    How long will it take to build a crypto
                                    trading platform?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    If you are a startup or an entrepreneur
                                    looking to launch your own cryptocurrency
                                    exchange platform right now, you may utilise
                                    our excellent white label crypto exchange
                                    software. So that you may construct a fully
                                    operating crypto exchange based on your
                                    company's requirements in only 7 days.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    How much does white label Crypto Exchange
                                    Software cost?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    The premium white label crypto exchange
                                    software development cost will be primarily
                                    determined by a few key elements. Such as
                                    the trading features and security modules
                                    you integrate, as well as the sort of
                                    cryptocurrency exchange you select for your
                                    firm.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
